import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';

export function postMapSetsVehicleGroupsAssign(
  id: number,
  vehicleGroupIds: number[]
) {
  return fromFetch(
    new Request(fleetEnvironment.mapSetsVehicleGroupsAssignUrl(id), {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
      body: JSON.stringify(vehicleGroupIds),
    })
  ).pipe(ignoreData());
}
